var e = { exports: {} };
export {
  e as __module
};
//# sourceMappingURL=index.es289.js.map
